"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Image = _interopRequireDefault(require("../Image"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var AccordionComponents = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
    banner = props.banner,
    sharp = props.sharp,
    radius = props.radius,
    source = props.source,
    className = props.className,
    children = props.children,
    onClick = props.onClick,
    style = props.style,
    _a = props.tabIndex,
    tabIndex = _a === void 0 ? 1 : _a,
    configuration = props.configuration,
    restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "className", "children", "onClick", "style", "tabIndex", "configuration"]);
  var childrenNodes;
  var chilen = configuration.length;
  var getHeightVal = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (getHeightVal.current) {
      childrenNodes = getHeightVal.current.childNodes;
      // todo optimize
      // 12 初始状态下少12 offsetHeight
      // 24 距离底部距离
      for (var i = 0; i < childrenNodes.length; i++) {
        if (i === 0) {
          getHeightVal.current.childNodes[i].childNodes[0].lastChild.style.height = "auto";
        } else {
          getHeightVal.current.childNodes[i].childNodes[0].lastChild.style.height = "0";
        }
      }
    }
  }, []);
  var checkTabsStatus = function checkTabsStatus(key) {
    var _childrenNodes = getHeightVal;
    var _loop_1 = function _loop_1(i) {
      // 查询到指定要获取高度
      var transformClass = _childrenNodes.current.childNodes[i].childNodes[0];
      if (i == Number(key) - 1) {
        if (transformClass.className.indexOf('am-accordion-item-leave') > -1) {
          setTimeout(function () {
            // 24 距离底部距离
            transformClass.lastChild.style.height = 'auto';
          });
          transformClass.className = 'am-accordion-item';
        } else {
          transformClass.lastChild.style.height = '0';
          transformClass.className = 'am-accordion-item-leave';
        }
      } else {
        transformClass.lastChild.style.height = '0';
        transformClass.className = 'am-accordion-item-leave';
      }
    };
    // todo optimize
    for (var i = 0; i < _childrenNodes.current.childNodes.length; i++) {
      _loop_1(i);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref,
    className: (0, _classnames["default"])('flex-default-accordion', className)
  }, restProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: "demoContainer"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "am-accordion my-accordion"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: getHeightVal
  }, configuration.map(function (item, i) {
    var title = item.title,
      tabTitle = item.tabTitle,
      key = item.key,
      content = item.content,
      filedVideoBg = item.filedVideoBg,
      filedVideoList = item.filedVideoList,
      imageSrc = item.imageSrc,
      extendProps = __rest(item, ["title", "tabTitle", "key", "content", "filedVideoBg", "filedVideoList", "imageSrc"]);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-tab',
      key: i
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])({
        'am-accordion-item': i === 0,
        'am-accordion-item-leave': i !== 0
      }),
      onClick: function onClick() {
        chilen !== 1 && checkTabsStatus(key);
      },
      style: chilen === 1 ? {
        background: 'none'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "am-accordion-title",
      role: "button",
      "aria-expanded": "false",
      style: chilen === 1 ? {
        display: 'none'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", null, tabTitle), /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      className: "design-iconfont d-icon"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      transform: "rotate(-180 12.25 12.25)",
      d: "M12.5 10.8035221L17.6191093 16 19 14.5982389 12.5 8 6 14.5982389 7.3808907 16z",
      fillRule: "evenodd"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-container'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "am-accordion-content",
      style: chilen === 1 ? {
        backgroundImage: 'none'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement(_Image["default"], __assign({
      width: 327,
      height: 184,
      filedVideoList: filedVideoList,
      filedVideoBg: filedVideoBg,
      style: {
        margin: '0 auto',
        backgroundSize: 'contain'
      },
      source: imageSrc
    }, extendProps)), /*#__PURE__*/_react["default"].createElement(ArticleComponent, {
      title: title,
      article: content,
      chilen: chilen
    })))));
  }))))));
});
AccordionComponents.displayName = 'TCIAccordionComponents';
var _default = exports["default"] = AccordionComponents; // 文章组件内容
var ArticleComponent = function ArticleComponent(props) {
  var source = props.source,
    record = props.record,
    onCallbackHandle = props.onCallbackHandle,
    className = props.className,
    hrefText = props.hrefText,
    href = props.href,
    title = props.title,
    article = props.article,
    chilen = props.chilen;
  var isShowArticle = article && article !== '<p></p>'; // 过滤富文本空字符
  if (!(href || source || title || isShowArticle)) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('Accordion__flex-default-article', className),
    onClick: function onClick() {
      if (!href) return;
      window.location.href = href;
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-article-container')
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: 'flex-default-article-container__section'
  }, source && (/*#__PURE__*/_react["default"].createElement(_Image["default"], {
    style: {
      margin: !!source && '0 0 12px 0',
      width: '163px',
      height: '54px'
    },
    source: source
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-article-container__section__content',
    onClick: function onClick() {
      onCallbackHandle && onCallbackHandle(record);
    }
  }, title && (/*#__PURE__*/_react["default"].createElement("strong", {
    className: 'wordBreak lineBreak',
    style: chilen === 1 ? {
      backgroundImage: 'none',
      fontSize: ' 24px',
      color: '#000',
      lineHeight: '36px'
    } : {
      fontSize: ' 24px',
      color: '#FFFFFF',
      lineHeight: '36px'
    }
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('accordion-div-content'),
    style: chilen === 1 ? {
      color: '#000'
    } : {},
    dangerouslySetInnerHTML: {
      __html: article || ''
    }
  }), href && (/*#__PURE__*/_react["default"].createElement("a", {
    className: 'flex-default-article_a',
    href: href
  }, hrefText || "Learn more ", " >"))))));
};